import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "./include/PageTitle";
import { useI18n } from "../i18n/I18nContext";
import { getServiceDetailsCopy, getSidebarLinks } from "../content/localeCopy";
import LocalizedLeadParagraph from "../Components/LocalizedLeadParagraph";
import { useTranslatedCopy } from "../i18n/useTranslatedCopy";
import ServiceInquiryForm from "../Components/ServiceInquiryForm";
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServiceStructuredData } from "../Components/Seo";

const brokeragePageImages = [
  "/img/service/brokerage-service-1.png",
  "/img/service/gallery_9.jpg",
  "/img/service/brokerage-service-3.png",
];

const brokerageSidebarImage = "/img/service/brokerage-service-4.png";

const imageCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(187, 165, 92, 0.14)",
  borderRadius: "22px",
  overflow: "hidden",
  boxShadow: "0 16px 38px rgba(15, 23, 42, 0.08)",
  height: "100%",
};

const RealStateBrokerageServiceDetails = () => {
  const { locale } = useI18n();
  const copy = useTranslatedCopy(getServiceDetailsCopy("brokerage"), locale);
  const sidebar = useTranslatedCopy(getSidebarLinks(), locale);
  const moreDetailsHeading = useTranslatedCopy("More about this service", locale);
  const matrixHeaderService = useTranslatedCopy("Service", locale);
  const matrixHeaderDetails = useTranslatedCopy("What We Provide", locale);
  const galleryCaptionOne = useTranslatedCopy("Buyer and seller coordination support", locale);
  const galleryCaptionTwo = useTranslatedCopy("Transaction readiness and guided follow-up", locale);
  const brokerageGalleryTitle = useTranslatedCopy("How we connect the right parties with confidence", locale);
  const brokerageGalleryText = useTranslatedCopy(
    "Our brokerage service focuses on matching, negotiation, due diligence and transaction follow-up so deals move forward with more clarity, stronger protection and less delay.",
    locale
  );
  const workflowHeading = useTranslatedCopy("Our Brokerage Workflow", locale);

  return (
    <div>
      <Seo
        title="Real Estate Brokerage in Saudi Arabia and Al Khobar | QTECH"
        titleAr="ÙˆØ³Ø§Ø·Ø© Ø¹Ù‚Ø§Ø±ÙŠØ© ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø¯Ù…Ø§Ù… | Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø©"
        description="QTECH provides real estate brokerage services in Saudi Arabia and Al Khobar for buying, selling, and leasing properties, supported by market analysis, valuation, negotiation, and contract documentation."
        descriptionAr="ØªÙˆÙØ± Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø© Ø®Ø¯Ù…Ø§Øª ÙˆØ³Ø§Ø·Ø© Ø¹Ù‚Ø§Ø±ÙŠØ© ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø¯Ù…Ø§Ù… ØªØ´Ù…Ù„ ÙˆØ³ÙŠØ· Ø¨ÙŠÙ† Ø§Ù„Ù…Ø§Ù„Ùƒ ÙˆØ§Ù„Ù…Ø´ØªØ±ÙŠØŒ ÙˆØ³ÙŠØ· Ø¨ÙŠÙ† Ø§Ù„Ù…Ø§Ù„Ùƒ ÙˆØ§Ù„Ù…Ø³ØªØ£Ø¬Ø±ØŒ Ø¹Ù‚ÙˆØ¯ Ø¹Ù‚Ø§Ø±Ø§ØªØŒ ÙˆØ¨ÙŠØ¹ ÙˆØªØ£Ø¬ÙŠØ± Ø§Ù„Ø¹Ù‚Ø§Ø±Ø§Øª."
        keywords={ENGLISH_SEO_KEYWORDS.brokerage}
        keywordsAr={ARABIC_SEO_KEYWORDS.brokerage}
        path="/real-estate-brokerage-saudi-arabia"
        image={brokeragePageImages[0]}
        structuredData={buildServiceStructuredData({
          name: "Real Estate Brokerage in Saudi Arabia | QTECH",
          nameAr: "Ã™Ë†Ã˜Â³Ã˜Â§Ã˜Â·Ã˜Â© Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å Ã˜Â© Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â¯Ã™â€¦Ã˜Â§Ã™â€¦ | Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â©",
          description:
            "QTECH provides real estate brokerage services in Saudi Arabia for buying, selling, and leasing properties, supported by market analysis, valuation, negotiation, and contract documentation.",
          descriptionAr:
            "Ã˜ÂªÃ™Ë†Ã™ÂÃ˜Â± Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â© Ã˜Â®Ã˜Â¯Ã™â€¦Ã˜Â§Ã˜Âª Ã™Ë†Ã˜Â³Ã˜Â§Ã˜Â·Ã˜Â© Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å Ã˜Â© Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â¯Ã™â€¦Ã˜Â§Ã™â€¦ Ã˜ÂªÃ˜Â´Ã™â€¦Ã™â€ž Ã™Ë†Ã˜Â³Ã™Å Ã˜Â· Ã˜Â¨Ã™Å Ã™â€  Ã˜Â§Ã™â€žÃ™â€¦Ã˜Â§Ã™â€žÃ™Æ’ Ã™Ë†Ã˜Â§Ã™â€žÃ™â€¦Ã˜Â´Ã˜ÂªÃ˜Â±Ã™Å Ã˜Å’ Ã™Ë†Ã˜Â³Ã™Å Ã˜Â· Ã˜Â¨Ã™Å Ã™â€  Ã˜Â§Ã™â€žÃ™â€¦Ã˜Â§Ã™â€žÃ™Æ’ Ã™Ë†Ã˜Â§Ã™â€žÃ™â€¦Ã˜Â³Ã˜ÂªÃ˜Â£Ã˜Â¬Ã˜Â±Ã˜Å’ Ã˜Â¹Ã™â€šÃ™Ë†Ã˜Â¯ Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã˜Â§Ã˜ÂªÃ˜Å’ Ã™Ë†Ã˜Â¨Ã™Å Ã˜Â¹ Ã™Ë†Ã˜ÂªÃ˜Â£Ã˜Â¬Ã™Å Ã˜Â± Ã˜Â§Ã™â€žÃ˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã˜Â§Ã˜Âª.",
          path: "/real-estate-brokerage-saudi-arabia",
          image: brokeragePageImages[0],
          serviceType: "Real Estate Brokerage",
        })}
      />

      <PageTitle
        title={copy.title}
        currentPage={copy.title}
        bgImage="/img/bg/14.jpg"
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <div className="ltn__blog-img">
                  <img
                    src={brokeragePageImages[0]}
                    alt={copy.imageLabel}
                    style={{ width: "100%", minHeight: "460px", objectFit: "cover" }}
                  />
                </div>

                <h2 className="title-2">{copy.imageLabel}</h2>

                {copy.paragraphs.map((text, index) => (
                  <LocalizedLeadParagraph
                    key={index}
                    text={text}
                    index={index}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.highlights) && copy.highlights.length > 0 ? (
                  <div className="qtech-service-highlight-list">
                    {copy.highlights.map((item, index) => (
                      <div className="qtech-service-highlight-card" key={item.title || index}>
                        <h5>{item.title}</h5>
                        <p>{item.body}</p>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div
                  style={{
                    marginTop: "34px",
                    marginBottom: "18px",
                    padding: "0 2px",
                  }}
                >
                  <h4
                    className="title-2"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {brokerageGalleryTitle}
                  </h4>
                  <p
                    style={{
                      marginBottom: "0",
                      color: "#5c727d",
                      lineHeight: "1.8",
                    }}
                  >
                    {brokerageGalleryText}
                  </p>
                </div>

                <div className="row g-4 mb-4">
                  {brokeragePageImages.slice(1).map((image, index) => {
                    const imageCaptions = [galleryCaptionOne, galleryCaptionTwo];

                    return (
                      <div className="col-md-6" key={image}>
                        <div style={imageCardStyle}>
                          <img
                            src={image}
                            alt={`${copy.imageLabel} ${index + 2}`}
                            style={{
                              width: "100%",
                              height: "290px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <div
                            style={{
                              padding: "16px 18px 18px",
                              background: "#fffdfa",
                              borderTop: "1px solid rgba(187, 165, 92, 0.12)",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "#bba55c",
                                marginBottom: "6px",
                              }}
                            >
                              {copy.imageLabel}
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: "#1f2937",
                                fontWeight: 600,
                                lineHeight: 1.6,
                              }}
                            >
                              {imageCaptions[index] || copy.imageLabel}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <h4 className="title-2 mt-4">{moreDetailsHeading}</h4>

                {(copy.moreDetails || []).map((text, index) => (
                  <LocalizedLeadParagraph
                    key={`below-images-${index}`}
                    text={text}
                    index={index + 10}
                    locale={locale}
                  />
                ))}

                <h4 className="title-2 mt-4">{workflowHeading}</h4>

                {Array.isArray(copy.serviceMatrix) && copy.serviceMatrix.length > 0 ? (
                  <div className="qtech-service-matrix">
                    <div className="qtech-service-matrix__header">
                      <span>{matrixHeaderService}</span>
                      <span>{matrixHeaderDetails}</span>
                    </div>
                    {copy.serviceMatrix.map((row, index) => (
                      <div className="qtech-service-matrix__row" key={row.service || index}>
                        <div className="qtech-service-matrix__service">{row.service}</div>
                        <div className="qtech-service-matrix__details">{row.details}</div>
                      </div>
                    ))}
                  </div>
                ) : null}

              </div>
            </div>

            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    {sidebar.map((item) => (
                      <li
                        key={item.to}
                        className={
                          item.to === "/real-estate-brokerage-saudi-arabia" ? "active" : ""
                        }
                      >
                        <Link to={item.to}>
                          {item.label}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <ServiceInquiryForm
                  serviceTitle={copy.title}
                  serviceSlug="real-estate-brokerage-saudi-arabia"
                />

                <div className="widget ltn__banner-widget">
                  <a href="/shop.html">
                    <img
                      src={brokerageSidebarImage}
                      alt={copy.imageLabel}
                      style={{ width: "100%", minHeight: "320px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealStateBrokerageServiceDetails;
